<template>
  <FixedTopBanner :enabled="showConnectionWarning">
    <v-alert type="error">
      <p>
        Parece que você está offline. Você não receberá informações atualizadas
        até que a conexão seja reestabelecida.
      </p>
    </v-alert>
  </FixedTopBanner>
</template>

<script>
import FixedTopBanner from "@/components/ui/fixed_top_banner.vue";
import { isActionCableConnectionOpen } from "@/config/apollo/actionCableLink.js";

const CABLE_WATCH_INTERVAL = 3000;

export default {
  name: "ActionCableStatus",
  components: { FixedTopBanner },
  data() {
    return {
      currentOpenStatus: true,
    };
  },
  mounted() {
    this.watchActionCableLink();
  },
  computed: {
    showConnectionWarning() {
      return !this.$store.state.actionCable.isOpen;
    },
  },
  methods: {
    watchActionCableLink() {
      setInterval(() => {
        this.checkActionCableLink();
      }, CABLE_WATCH_INTERVAL);
    },
    checkActionCableLink() {
      const newOpenStatus = this.isConnectionOpen();

      if (this.currentOpenStatus != newOpenStatus) {
        this.currentOpenStatus = newOpenStatus;
        this.triggerStatusUpdate(newOpenStatus);
      }
    },
    triggerStatusUpdate(isOpen) {
      this.$store.dispatch("updateCableOpenStatus", isOpen);
    },
    isConnectionOpen() {
      return isActionCableConnectionOpen();
    },
  },
};
</script>

<style scoped></style>
